import { FC, PropsWithChildren } from 'react'
import styled from '../../styled'
import {
  BottomSheet as YaComBottomSheet,
  BottomSheetProps as YaComYaComBottomSheetProps,
} from '@yanolja-rnd/ya-com-bottom-sheet'

const ButtonContainer = styled.div`
  text-align: center;
  padding: 1.2rem 2rem 1.6rem;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 0 0 auto;

  & > button {
    margin-right: 0.8rem;
    :nth-last-of-type(1) {
      margin-right: 0;
    }
  }
`
interface BottomSheetProps extends YaComYaComBottomSheetProps {
  hideButtons?: boolean
}
const BottomSheet: FC<PropsWithChildren<BottomSheetProps>> = function ({
  buttons,
  hideButtons = false,
  ...props
}) {
  return (
    <YaComBottomSheet
      buttons={!hideButtons ? <ButtonContainer>{buttons}</ButtonContainer> : undefined}
      {...props}
    />
  )
}

export default BottomSheet
